import React, { lazy } from 'react';
import { CheckIcon, CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const productImage = 'https://cdn.magicpatterns.com/uploads/wKiYjBGbfXPbsstPzCSzzt/Diseno-sin-titulo-_67_.webp';
const items = ['6 volumi didattici completi di Pilates', '5 bonus strategici esclusivi', '60+ sessioni pronte all’uso', 'Accesso a vita al materiale digitale', 'PDF alta qualità per Tablet e Stampa'];
export function PricingSection() {
  return <section id="offerta" className="bg-[#fff7fb] px-5 py-20" data-id="element-144" data-mp="1s93yj8zl2f1d">
      <div className="mx-auto max-w-xl text-center" data-id="element-145" data-mp="1sbq3d0v3agfw">
        <p className="inline-block bg-[#241322] px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-146" data-mp="1x9rqpxzjt1x6">
          Offerta speciale di lancio
        </p>
        <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-none text-[#241322] sm:text-5xl" data-id="element-147" data-mp="2up6oft9qc1n">
          Tutto incluso,{' '}
          <span className="text-emerald-700" data-id="element-148" data-mp="7ul7k66o5ncz">un unico prezzo.</span>
        </h2>
        <p className="mt-3 text-sm font-semibold text-slate-600" data-id="element-149" data-mp="1mgy46xewhepi">
          Nessun abbonamento. Nessuna sorpresa.
        </p>
        <article className="mt-10 overflow-hidden border border-emerald-950/10 bg-white text-center shadow-xl" data-id="element-150" data-mp="1hodf296xvpsb">
          <header className="border-t-4 border-emerald-500 bg-[#241322] px-6 py-7" data-id="element-151" data-mp="1cr4tdyml13mb">
            <h3 className="font-display text-3xl font-bold uppercase text-white" data-id="element-152" data-mp="17td47cdbnvlt">
              PILATES PRONTA™ — Pacchetto completo
            </h3>
            <p className="mt-2 text-sm font-semibold text-emerald-300" data-id="element-153" data-mp="20gpfgqe18gzt">
              6 Volumi + 5 Bonus Strategici
            </p>
          </header>
          <div className="p-7 sm:p-10" data-id="element-154" data-mp="1vfrwwcp41kxs">
            <img src={productImage} alt="Pacchetto completo PILATES PRONTA" width={1080} height={1080} loading="lazy" className="mx-auto -mt-3 mb-3 w-full max-w-md object-contain" data-id="element-155" data-mp="1rfrjmvdqzfsb" />
            <div id="dettagli-offerta" className="mb-8 scroll-mt-3 border-y border-emerald-950/10 py-7" data-id="element-156" data-mp="g2p5s83194bu">
              <p className="mb-5 text-xs font-bold uppercase tracking-widest text-[#241322]" data-id="element-157" data-mp="mh4exg14g0oo">
                Cosa include
              </p>
              <ul className="grid gap-3 text-left sm:grid-cols-2" data-id="element-158" data-mp="7jc3ayyp3wfr">
                {items.map(item => <li key={item} className="flex items-center gap-2 text-sm font-semibold text-[#241322]" data-id="element-159" data-mp="ckrm0kdehquz">
                    <span className="grid h-5 w-5 place-items-center rounded-full bg-emerald-100" data-id="element-160" data-mp="3is65ve4gstm">
                      <CheckIcon className="h-3.5 w-3.5 text-emerald-700" data-id="element-161" data-mp="3kzt6jna832l8" />
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="mt-7" data-id="element-162" data-mp="3bz3i54nakehj">
              <p className="text-sm font-semibold text-slate-600" data-id="element-163" data-mp="3c065x3pbi0t8">
                Valore totale: <s data-id="element-164" data-mp="3fym320f44pkd">€106</s>
              </p>
              <div className="mt-1 flex items-baseline justify-center text-[#241322]" data-id="element-165" data-mp="2xalafj2s3911">
                <span className="font-display text-5xl font-bold" data-id="element-166" data-mp="2sc9xv0l3mkf4">€</span>
                <strong className="font-display text-8xl font-bold leading-none tracking-tight" data-id="element-167" data-mp="2se34ifvpp4n4">
                  19
                </strong>
              </div>
              <div className="mt-3 flex flex-wrap justify-center gap-3" data-id="element-168" data-mp="31bx1lt1aw2bc">
                <span className="bg-emerald-500 px-3 py-1.5 text-xs font-bold uppercase tracking-widest text-white" data-id="element-169" data-mp="3g9fm2j6y3tcz">
                  Risparmi €87
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-170" data-mp="3b91nrsv5bxs5">
                  Pagamento unico
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-171" data-mp="3l1z0fidgisiu">
                  Accesso a vita
                </span>
              </div>
            </div>
            <a href="https://pilates-pronta.impultienda.ar/checkout" className="cta-button -mx-2 mt-6 block w-[calc(100%+1rem)] rounded-2xl px-6 py-6 text-xl font-bold sm:text-2xl" data-id="element-172" data-mp="3u2otwff8w6te">
              SÌ! VOGLIO PILATES PRONTA
            </a>
            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-slate-600" data-id="element-173" data-mp="qq4jipcox36u">
              <ShieldCheckIcon className="h-4 w-4 text-emerald-700" data-id="element-174" data-mp="vofvb5mjpnrp" />
              Coperto dalla nostra garanzia soddisfatti o rimborsati di 7 giorni
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 border-t border-emerald-950/10 pt-6 text-xs font-bold text-slate-600" data-id="element-175" data-mp="30k065cmk3x1">
              <span className="flex gap-1" data-id="element-176" data-mp="7ybroy9cxo0p">
                <LockKeyholeIcon className="h-4 w-4" data-id="element-177" data-mp="cyzok0k9oz2u" />
                Pagamento sicuro
              </span>
              <span className="flex gap-1" data-id="element-178" data-mp="1jfbqmcq7n13p">
                <ZapIcon className="h-4 w-4" data-id="element-179" data-mp="1jejvf30iz5dy" />
                Accesso immediato
              </span>
              <span className="flex gap-1" data-id="element-180" data-mp="1oclg1sdlncrj">
                <CreditCardIcon className="h-4 w-4" data-id="element-181" data-mp="38vxmqoxarhru" />
                Carta · Google Pay · Apple Pay
              </span>
            </div>
          </div>
        </article>
        <p className="mt-5 text-xs font-semibold text-slate-600" data-id="element-182" data-mp="33z76o1lhsm6f">
          Prezzo finale in euro, pagamento una tantum e accesso immediato al
          materiale digitale.
        </p>
      </div>
    </section>;
}